import React from 'react';
import useMobileBreakpoints from '../../../../../../common/src/hooks/useMobileBreakpoints';
import QuestionGroupActions from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupActions';
import VehicleDataYesNoButtons from './VehicleDataYesNoButtons';

interface Props {
  onGoNext: () => void;
  previousSubView: () => void;
  setIsModalOpen: (arg0: boolean) => void;
}

const VehicleDataActions: React.FC<React.PropsWithChildren<Props>> = ({
  previousSubView,
  onGoNext,
  setIsModalOpen,
}) => {
  const { isLaptop } = useMobileBreakpoints();

  return (
    <QuestionGroupActions
      onBack={previousSubView}
      hideContinueButton
      isVertical={isLaptop}
    >
      <VehicleDataYesNoButtons
        showMobile
        handleYes={onGoNext}
        handleNo={() => setIsModalOpen(true)}
      />
    </QuestionGroupActions>
  );
};

export default VehicleDataActions;
